import script from "./SettingsDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDialog.vue?vue&type=script&setup=true&lang=js"

import "./SettingsDialog.vue?vue&type=style&index=0&id=77938dae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77938dae"]])

export default __exports__